<div class="page-container" *ngIf="!isLoading">
    <div class="page-title-container">
        <mat-icon svgIcon="network-settings" class="page-title-icon" />
        <div>
            {{ 'sidebar.menu.communication-protocols.label' | translate }}
        </div>
    </div>

    <div class="main-content-container">
        <div class="add-button-container">
            <app-button
                (onClick)="createProtocol()"
                text="communication-protocols.add-protocol"
                [iconButton]="true"
                iconSize="20px"
                icon="plus">
            </app-button>
        </div>
        <div class="main-content">
            <div class="table-row table-header">
                <div class="col-name column">
                    {{ 'communication-protocols.table.header.name' | translate }}
                </div>
                <div class="col-type column">
                    {{ 'communication-protocols.table.header.type' | translate }}
                    <div class="config-info-message">
                        <mat-icon
                            svgIcon="info"
                            class="info-icon"
                            (mouseenter)="isInfoMessageVisible = true"
                            (mouseleave)="isInfoMessageVisible = false"></mat-icon>
                        <ng-container *ngIf="isInfoMessageVisible">
                            <div #infoMessage class="info-message-container">
                                <div>
                                    {{ 'communication-protocols.table.header.type.info' | translate }}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="col-board-type column">
                    {{ 'communication-protocols.table.header.board-type' | translate }}
                </div>
                <div class="col-options column"></div>
            </div>
            <div *ngFor="let protocol of communicationProtocols" class="table-row">
                <div class="col-name column">
                    {{ protocol.name }}
                </div>
                <div class="col-type column">
                    {{ getProtocolType(protocol) | translate }}
                </div>
                <div class="col-board-type column">
                    {{ getBoardType(protocol) | translate }}
                </div>
                <div class="col-options column" #iconButton>
                    <mat-icon
                        svgIcon="more-options"
                        class="more-options"
                        (click)="openOptions(protocol); $event.stopPropagation()">
                    </mat-icon>
                    <ng-container *ngIf="visibleProtocolOptions == protocol">
                        <div class="more-options-container" #otherOptions>
                            <div class="option-row" (click)="edit(protocol)">
                                {{ 'dlg.edit' | translate }}
                            </div>
                            <div class="option-row" (click)="deleteProtocol(protocol)">
                                {{ 'dlg.delete' | translate }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>
</div>
